import type { ReactElement } from 'react';
import type { RouteObject } from 'react-router';

import { aideWeb } from '../aide/index.js';

import { affichageWeb } from './affichage/index.js';
import { benevolatWeb } from './benevolat/index.js';
import { boutiqueWeb } from './boutique/index.js';
import { connecteursWeb } from './connecteurs/index.js';
import { criseWeb } from './crise/index.js';
import { engagementWeb } from './engagement/index.js';
import { exampleWeb } from './example/index.js';
import { logistiqueWeb } from './logistique/index.js';
import { mediasWeb } from './medias/index.js';
import { operationsWeb } from './operations/index.js';
import { reconnaissanceWeb } from './reconnaissance/index.js';
import { repasWeb } from './repas/index.js';
import { socleWeb } from './socle/index.js';
import { sondagesWeb } from './sondages/index.js';
import { supportWeb } from './support/index.js';
import { telephonieWeb } from './telephonie/index.js';

/**
 * Contributions web des modules (points d'extension `navigation` et `homeTiles` des
 * descripteurs, contrat module-descriptor.md). Une route n'est atteignable que si le
 * serveur l'a placée dans la navigation de l'utilisateur ; chaque écran revérifie ses
 * droits côté serveur. Le générateur `pnpm module:new` ajoute ici l'entrée du nouveau
 * module (marqueur ci-dessous).
 */
export interface ModuleWeb {
  module: string;
  routes: RouteObject[];
  /** Rendu personnalisé d'une tuile d'accueil (sinon : valeur et lien fournis par le serveur). */
  tiles?: Record<string, () => ReactElement>;
  /**
   * Onglets ajoutés à la fiche Personne (point d'extension unique, specs 005 T043 et 008 T100) ;
   * chaque onglet revérifie ses droits côté serveur. `gestionOnly` : onglet réservé à la fiche
   * vue en gestion (masqué sur « Ma fiche »).
   */
  personTabs?: {
    key: string;
    label: string;
    gestionOnly?: boolean;
    render: (personId: string) => ReactElement;
  }[];
  /**
   * Onglets ajoutés à la fiche Activité des Opérations (ex. « Repas » : commandes, choix des
   * bénévoles, fournisseur) ; chaque onglet revérifie ses droits côté serveur.
   */
  activityTabs?: {
    key: string;
    label: string;
    render: (activityId: string) => ReactElement;
  }[];
  /**
   * Blocs de l'accueil bénévole, après « Ma prochaine activité » (chantier Q : « Mon
   * engagement »). Montré seulement si l'écran `path` est dans la navigation permise (module
   * actif, droit détenu) ; le bouton d'action de même adresse n'est alors pas répété. Le bloc
   * charge ses données lui-même, sans retarder l'accueil.
   */
  homeBlocks?: {
    key: string;
    path: string;
    render: () => ReactElement;
  }[];
}

export const MODULE_WEB: ModuleWeb[] = [
  socleWeb,
  exampleWeb,
  operationsWeb,
  supportWeb,
  reconnaissanceWeb,
  boutiqueWeb,
  engagementWeb,
  mediasWeb,
  criseWeb,
  benevolatWeb,
  sondagesWeb,
  repasWeb,
  logistiqueWeb,
  affichageWeb,
  telephonieWeb,
  connecteursWeb,
  aideWeb,
  // oasis:module-screens
];
